export var ACTION;
(function (ACTION) {
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["NAVIGATION"] = "NAVIGATION";
    ACTION["EMAIL"] = "EMAIL";
    ACTION["ENHANCE_LIMIT"] = "ENHANCE_LIMIT";
    ACTION["MARGIN_CALL"] = "MARGIN_CALL";
    ACTION["OLD_NAVIGATION"] = "OLD_NAVIGATION";
    ACTION["MENU"] = "MENU";
    ACTION["MAIL_POPUP"] = "MAIL_POPUP";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["INCREASE_LIMIT_ACTION"] = "INCREASE_LIMIT_ACTION";
    ACTION["PENDING_LIMIT_ACTION"] = "pendingRequestAction";
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["RENEW_NOW"] = "RENEW_NOW";
    ACTION["LOAN_EXPIRED_REPAYMENT"] = "LOAN_EXPIRED_REPAYMENT";
    ACTION["REOPEN_LOAN_ACCOUNT"] = "REOPEN_LOAN_ACCOUNT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["REFUND_LOAN"] = "REFUND_LOAN";
})(ACTION || (ACTION = {}));
